import { actions } from "../../actions/action-list";
import initialState from "./initialState";

const Cities = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.FETCH_CITIES:
      return { ...state, cities: action.value };
    case actions.SELECTED_CITY:
      return { ...state, selectedCity: action.value };
    default:
      return state;
  }
};
export default Cities;
